<mat-chip-list [selectable]="false" class="mat-chip-list-stacked" aria-orientation="vertical">
  <mat-chip *ngFor="let value of items" [value]="value" [removable]="true" (removed)="onRemove($event)">
    <ng-container *ngTemplateOutlet="chipDef.template; context: { $implicit: value }"></ng-container>
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip>
</mat-chip-list>
